// extracted by mini-css-extract-plugin
export default {"followinterval":"History_followinterval__r5QS1"};